import React, {Component} from 'react'

import {
  Typography,
} from 'material-ui'

import SubscriptionForm from './SubscriptionForm'

const style = {
  section:{
    background:'radial-gradient(ellipse 100% 100% at 90% 90%, #9271f6, #3f51b5)',
    minWidth: '100vw',
    margin:0,
    position:'relative',
    overflow:'hidden',
    flexDirection:'row',
    right: 0,
    display: 'flex',
    maxHeight: '1080px',
    justifyContent:'center',
    alignItems:'center',
  },
  contactContainer:{
    minWidth:'310px',
    maxWidth:'500px',
    width:'90%',
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    color:'white',
  },
  logo:{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
    width: '100px',
    borderRadius: '50px',
    background: 'white',
    color: '#ff4081',
    fontSize: '3rem',
    overflow: 'hidden',
    marginBottom: '50px',
    transition:'box-shadow 0.3s ease',
  },
  headline:{
    color: 'white',
    fontWeight: '500',
    textAlign: 'center',
  },
  message:{
    fontSize: '1.5rem',
    margin: '21px 0px 51px 0px',
    textAlign: 'center',
    color:'white',
    fontWeight:'300',
  },
}

export default class LandingPageContact extends Component{
  render(){
    return (
      <section style={style.section} className="loggedOutBody">
        <div style={style.contactContainer}>
          <div className="logo" style={style.logo}>
            Ѳ
          </div>
          <Typography style={style.headline} type={"display2"}>Make Your NetWork</Typography>
          <Typography style={style.message} type={"headline"}>Register to join our beta.</Typography>
          <div style={style.form} >
            <SubscriptionForm />
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageContact.js